<style lang="scss" scoped>
.class-container {
	width: 282px;
	margin-top: 10px;
	&__members {
	   font-size: 10px;
	   margin: 0 0 0 0px;
	}
	&__name {
		margin-left: 10px;
		font-size: 15px;
		font-weight: 800;
	}
	&__right {
		float: right;
		font-size: 8px;
	}
	&__border-bottom {
		border-bottom: 1px solid #eee;
	}
	&__edit-button {
		margin-left:-10px;
		font-size:12px;
		padding: 7px;
	}
	&__edit-button-group {
		height: 40px;
	}
	&__new {
		background-color: rgba(103, 194, 58, .1);
		border-color: rgba(103,194,58,.2);
	}
	&__scroll {
		overflow: auto;
		height: 150px;
	}
}
.class-container__scroll {
}
.clearfix:before,
.clearfix:after {
	display: table;
	content: "";
}
.clearfix:after {
	clear: both
}
.fe-menu {
	cursor: pointer;
}
</style>
<template lang="pug">
div.class-container
	el-card.class-container__box(bodyStyle="padding: 0")
		div.clearfix(slot="header")
			.class-container__edit-off(v-if="!isEditing")
				el-dropdown(@command="edit" trigger="click", v-if="!readOnly")
					<i class="fe fe-menu"></i>
					el-dropdown-menu(slot='dropdown')
						el-dropdown-item(command="owner", v-if="this.state !== 'new'") Update owner
						el-dropdown-item(command="title") Edit name
						el-dropdown-item(command="remove", v-if="this.state !== 'archive'") Remove
						el-dropdown-item(command="remove", v-if="this.state === 'archive'") Undo remove
				span.class-container__name(v-if="!isEditing" @click="editTitle") {{ className | truncate(23) }}
				input.class-container__name(v-else type="text" v-model="className" @blur="saveTitle" @keyup.enter="saveTitle" ref="editInput")
				el-tag.class-container__right(size="small", type="warning", v-if="state === 'new'") NEW
				el-tag.class-container__right(size="small", type="danger", v-if="state === 'archived'") ARCHIVED
				el-tag.class-container__right(size="small", type="success", v-if="state === 'active'") ACTIVE
				el-tag.class-container__right(size="small", type="danger", v-if="state === 'archive'") FOR ARCHIVING
				div.class-container__members(v-if="this.state !== 'new'") {{ membersCount }} member{{ membersCount > 1 ? "s" : ""}}
			.class-container__edit-on(v-else) 
					el-row
						el-row
							el-col(:span="14")
								el-input.class-container__header-input(v-model="tempClassName")
							el-col(:span="10")
								el-button-group
									el-button.class-container__edit-button-group(size="mini", icon="el-icon-circle-check", @click="saveTitle")
									el-button.class-container__edit-button-group(size="mini", icon="el-icon-circle-close", @click="cancelEdit")
		div.class-container__scroll
			//- mis-class.class-container__border-bottom.class-container__new
			mis-class.class-container__border-bottom(
				v-for="classId in classIds" :id="classId" 
				draggable 
				@dragstart.native="drag($event, classId)", 
				@remove-class="removeClass", 
				:misClasses="misClasses", 
				:allowRemoval="!readOnly", 
				@create-class="createClass",
				:matchesInput="matchesInput",
				:providerClass="providerClass"
			)
		members-dialog(:isDialogVisible.sync="isDialogVisible" :members="members" :selectedClass="providerClass", @close-members-dialog="closeMembersDialog")
		
</template>

<script>
import MisClass from './MISClass.vue';
import MembersDialog from './MembersDialog.vue'
import gql from "graphql-tag";

export default {
	props: {
    	providerClass: Object,
		misClasses: Array,
		readOnly: Boolean,
		matchesInput: Array,
		persistedMatches: Array,
	},
	components: {
		MisClass,
		MembersDialog
	},
	data() {
		return {
			isEditing: false,
			className: this.providerClass.name,
			isDialogVisible: false,
			tempClassName: this.providerClass.name,
			thirdPartyClass: {
				members: [],
			}
		};
	},
	watch: {
		visibleClass(newVal) {
			this.className = newVal.name;
		}
	},
	mounted() {
		const dropZone = this.$el.querySelector('.class-container__scroll');
		if (dropZone) {
			dropZone.addEventListener('drop', (event) => {
				console.log(event)
				this.dropClass(event, this.providerClass.id);
			});

			dropZone.addEventListener('dragover', (event) => {
				event.preventDefault();
			});

			dropZone.addEventListener('dragenter', (event) => {
				event.preventDefault();
			});
		}
	},
	computed: {
		state() {
			return this.providerClass.courseState ? this.providerClass.courseState.toLowerCase() : "";
		},
		classIds() {
			return this.providerClass.misClasses;
		},
		members() {
			return _.map(this.thirdPartyClass.members, (member) => {
				if (!_.isEmpty(this.providerClass.ownerId) && (member.id === this.providerClass.ownerId || (this.providerClass.ownerId.split(",").includes(member.id)))) {
					member.isOwner = true;
				} else {
					member.isOwner = false;
				}

				return member;
			});
		},
		students() {
			return this.members;
		},
		membersCount() {
			return this.thirdPartyClass.members ? this.thirdPartyClass.members.length : 0;
		}
	},
	methods: {
		edit(command) {
			switch (command) {
				case "owner":
					this.editOwner();
					break;
				case "remove":
					this.removeMatch(this.providerClass.id);
					break;
				default:
					this.editTitle();
					break;
			}
		},
		editOwner() {
			this.isDialogVisible = true;
		},
		editTitle() {
			this.isEditing = true;
		},
		saveTitle() {
			this.isEditing = false;
			this.className = this.tempClassName;
			this.$emit("update-name", this.providerClass.id, this.className);
		},
		removeClass(classId) {
			this.providerClass.misClasses = this.providerClass.misClasses.filter((id) => id !== classId);
			// do save in other ticket to handle updating the db
		},
		drag(ev, classId) {
			ev.dataTransfer.setData("draggedClassId", classId);
		},
		dropClass(ev, targetSpClass) {
			const classToMove = ev.dataTransfer.getData("draggedClassId");

			if (_.isEmpty(classToMove) || this.providerClass.misClasses.includes(classToMove) || this.state === "remove") return;

			this.providerClass.misClasses.push(classToMove);
		},
		removeMatch(classId) {
			this.$emit('remove-match', classId);
		},
		createClass(id) {
		},
		cancelEdit() {
			this.isEditing = false;
			this.tempClassName = this.className;
		},
		closeMembersDialog() {
			this.isDialogVisible = false;
		}
	},
	apollo: {
		thirdPartyClass: {
			query: gql`
				query ThirdPartyClass($classId: String!, $members: [String!]!) {
					ThirdPartyClass(classId: $classId, members: $members) {
						id
						emailAddress
						members {
							id
							name
						}
					}
				}
			`,
			variables() {
				return {
					classId: this.providerClass.id,
					members: ["teachers"],
				}
			},
			fetchPolicy: "cache-and-network",
			update(r) {
				return r.ThirdPartyClass;
			}
		},
	}
};
</script>